import React, { useRef } from 'react';

import { Splitter, SplitterPanel } from 'primereact/splitter'
import CallersTable from '../CallersTable';
import TextEditor from '../TextEditor';
import BottomBar from '../BottomBar';

const Admin = ({ toast, setCallersBlocked, setEditorBlocked, sendMessage, notification, setNotification }) => {
    return (
        <Splitter style={{ width: '100%', height: '100%' }} layout="vertical">
            <SplitterPanel className="flex flex-column overflow-hidden" size={20} minSize={0}>
                <CallersTable setBlocked={setCallersBlocked} toast={toast} sendMessage={sendMessage} notification={notification} editable={true}/>
            </SplitterPanel>
            <SplitterPanel className="flex flex-column" size={80} minSize={10}>
                <Splitter layout="vertical">
                    <SplitterPanel className="flex flex-column relative" size={90} minSize={20}>
                        <TextEditor setBlocked={setEditorBlocked} toast={toast} sendMessage={sendMessage} notification={notification} editable={true}/>
                    </SplitterPanel>
                    <SplitterPanel className="flex flex-row p-3 gap-5 align-items-center" size={10} minSize={10}>
                        <BottomBar sendMessage={sendMessage} notification={notification} setNotification={setNotification} editable={true}/>
                    </SplitterPanel>
                </Splitter>
            </SplitterPanel>
        </Splitter>
    );
}

export default Admin; 